import React, {Component} from "react";
import app_cs from "./mCylinder.module.css";
import './mCylinder.css'


class App extends Component {
    constructor(props) {
        super(props);

    }

    genarateScroll(){
        let result =[];

        //mostly change these two
        let _picWidth =2040;
        let _z =(_picWidth/(2*Math.PI));


        let _n =60;
        let _ybasicDegree = 360/_n;
        let _pieceWidth = Math.ceil(_picWidth/_n);

        // result.push(  <div className={app_cs[0]} key={0} style={{width:`${_pieceWidth+1}px`, backgroundPosition:'0 0',transform:`rotateY(0deg) translateZ(${_z}px)`}}> </div>)
        for(let i=0;i<_n;i++){
            let _backgroundPosition = ((_picWidth) -(i)* _pieceWidth);
            let _y = _ybasicDegree*i;
            result.push(
                <div className={app_cs['pieceWrapper']} key={i}>
                    <div className={app_cs['pieceMain']}  style={{width:`${_pieceWidth+1}px`,backgroundPosition:`${_backgroundPosition}px 0`,transform:`rotateY(${_y}deg) translateZ(${_z}px)`}}> </div>
                    <div className={app_cs["pieceShadow"]}  style={{width:`${_pieceWidth}px`,height:'13px',transform:`rotateY(${_y}deg) translateZ(${_z}px)`}}></div>
                    <div className={app_cs['pieceDown']}  style={{width:`${_pieceWidth}px`,backgroundPosition:`${_backgroundPosition}px 0`,transform:`rotateY(${_y}deg) translateZ(${_z}px) scaleY(-1) `}}> </div>
                </div>
            )
        }
        return result;
    }

    render() {
        return (
            <div className={app_cs['home-wrapper']}>
                <div id="container" className={app_cs['container']}>

                    <div className={app_cs['frame']}>
                        <div className={app_cs['strip']} style={{animation: 'mspin 25s infinite linear'}} >
                            {this.genarateScroll()}
                        </div>
                    </div>
                </div>
            </div>)
    }
}

export default App;